import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useRef, useState } from 'react';

import { useAppSelector, useCurrentAccount, useCurrentNetwork } from 'hooks';
import { useMultiLanguage } from 'services';
import { AssetsList } from 'components/ui/molecule/AssetsList';
import { PopIn } from 'components/ui/molecule/PopIn';
import { PopperTooltip } from 'components/ui/molecule/PopperTooltip';
import { openExplorerTab } from 'utils/utils';
import { AccountDrawer } from '../AccountDrawer';
import { AccountDetailsModal } from '../AccountDetailsModal';
import { ConnectInfoModal } from '../ConnectInfoModal';
import {
  AccountDetailButton,
  AccountDetails,
  AccountDetailsContent,
  AccountImageStyled,
  AccountLabel,
  CopyIcon,
  DivList,
  InfoIcon,
  PopInStyled,
  RowDiv,
  Wrapper,
} from './SideBar.style';

export const SideBarView = () => {
  const { translate } = useMultiLanguage();
  const currentNework = useCurrentNetwork();
  const { address, accountName } = useCurrentAccount();
  const erc20TokenBalances = useAppSelector(
    (state) => state.wallet.erc20TokenBalances,
  );
  const connected = useAppSelector((state) => state.wallet.connected);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [listOverflow, setListOverflow] = useState(false);
  const [infoModalOpen, setInfoModalOpen] = useState(false);
  const [accountDetailsOpen, setAccountDetailsOpen] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [starkName, setStarkName] = useState<string | undefined>(undefined);
  const ref = useRef<HTMLDivElement>();
  const chainId = currentNework?.chainId;

  useEffect(() => {
    if (ref.current) {
      const clientHeight = ref.current.clientHeight;
      if (clientHeight >= 344) {
        setListOverflow(true);
      } else {
        setListOverflow(false);
      }
    }
  }, [erc20TokenBalances]);

  return (
    <Wrapper>
      <PopInStyled
        isOpen={accountDetailsOpen}
        setIsOpen={setAccountDetailsOpen}
      >
        <AccountDetailsModal />
      </PopInStyled>
      <PopIn
        isOpen={infoModalOpen}
        setIsOpen={setInfoModalOpen}
        showClose={false}
      >
        <ConnectInfoModal
          onButtonClick={() => setInfoModalOpen(false)}
          address={address}
        />
      </PopIn>
      <AccountDetails
        arrowVisible={false}
        closeTrigger="click"
        offSet={[60, 0]}
        content={
          <AccountDetailsContent>
            <AccountDetailButton
              backgroundTransparent
              iconLeft="qrcode"
              onClick={() => setAccountDetailsOpen(true)}
            >
              {translate('accountDetails')}
            </AccountDetailButton>
            <AccountDetailButton
              backgroundTransparent
              iconLeft="external-link"
              onClick={() => openExplorerTab(address, 'parties', chainId)}
            >
              {translate('viewOnExplorer')}
            </AccountDetailButton>
          </AccountDetailsContent>
        }
      >
        <AccountImageStyled address={address} connected={connected} />
      </AccountDetails>

      <AccountLabel>{accountName}</AccountLabel>
      <RowDiv>
        <InfoIcon onClick={() => setInfoModalOpen(true)}>i</InfoIcon>
        <AccountDrawer starkName={starkName} />
        <PopperTooltip content="Copied!" closeTrigger="click">
          <CopyIcon
            onClick={async () => navigator.clipboard.writeText(address)}
          >
            <FontAwesomeIcon icon="copy" />
          </CopyIcon>
        </PopperTooltip>
      </RowDiv>
      <DivList ref={ref as any}>
        <AssetsList />
      </DivList>
    </Wrapper>
  );
};
